import { render } from "./commisionAmountTable.vue?vue&type=template&id=1d8c7719"
import script from "./commisionAmountTable.vue?vue&type=script&lang=js"
export * from "./commisionAmountTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__